import React from 'react';
import { SplashMessageContext } from './SplashMessageContext';

const withSplashMessage = Component => {
  return function withSplashMessageComponent(props) {
    // Pulling out messages so can use in lifecycle method - Necessary for new error message designs
    return (
      <SplashMessageContext.Consumer>
        {({ messages, ...rest }) => (
          <Component {...props} {...rest} messages={messages} />
        )}
      </SplashMessageContext.Consumer>
    );
  };
};

export default withSplashMessage;



// WEBPACK FOOTER //
// ./src/components/splashMessage/withSplashMessage.js